// ============================================================
// Public marketing shell at `/` (main site before the game)
// ============================================================

import { getAuthUserOrNull } from '../auth/authGate';

function el(id: string): HTMLElement | null {
  return document.getElementById(id);
}

export function hideLanding(): void {
  document.body.classList.remove('site-mode-landing');
  const root = el('landing-screen');
  if (root) root.style.display = 'none';
}

/** Show the home / marketing layer and refresh “logged in” hints. */
export async function showLanding(): Promise<void> {
  document.body.classList.add('site-mode-landing');
  document.body.classList.remove('site-mode-login', 'site-mode-play');

  const auth = el('auth-screen');
  if (auth) auth.style.display = 'none';

  const root = el('landing-screen');
  if (root) root.style.display = 'flex';

  const hint = el('landing-session-strip');
  if (!hint) return;

  void refreshLandingSessionStrip(hint);
}

async function refreshLandingSessionStrip(hint: HTMLElement): Promise<void> {
  const user = await getAuthUserOrNull();
  if (user) {
    const name =
      (user.name && user.name.trim()) ||
      user.email.split('@')[0] ||
      'Traveler';
    hint.textContent = `Signed in as ${name}. Play Free below goes straight to the game.`;
  } else {
    hint.textContent = '';
  }
}
